<template>
  <div class="table-mundial-group">
    <div class="table-mundial-group__grouptitle" v-if="header">{{ data.name }}</div>
    <div class="table-mundial-group__head">
      <div class="table-mundial-group__head__div-table-col-head position" align="center">
        POS
      </div>
      <div class="table-mundial-group__head__div-table-col-head teamtable">
        EQUIPO
      </div>
      <div class="table-mundial-group__head__div-table-col-head jj">JJ</div>
      <div class="table-mundial-group__head__div-table-col-head jg">JG</div>
      <div class="table-mundial-group__head__div-table-col-head je">JE</div>
      <div class="table-mundial-group__head__div-table-col-head jp">JP</div>
      <div class="table-mundial-group__head__div-table-col-head gf movil-game-flag-g">
        GF
      </div>
      <div class="table-mundial-group__head__div-table-col-head gc movil-game-flag-g">
        GC
      </div>
      <div class="table-mundial-group__head__div-table-col-head dg movil-game-flag-g">
        DG
      </div>
      <div class="table-mundial-group__head__div-table-col-head pts">PTS</div>
      <template v-if="header">
        <div class="table-mundial-group__head__div-table-col-head lastgames movil-game-flag-lastgame">
          ÚLTIMOS JUEGOS
        </div>
        <div class="table-mundial-group__head__div-table-col-head lastgames movil-game-flag-lastgame-movil">
          U. JUEGOS
        </div>
      </template>
      <template v-else>
        <div class="table-mundial-group__head__div-table-col-head lastgames ">
          U. JUEGOS
        </div>
      </template>

      <div class="table-mundial-group__head__div-table-col-head prox">PROX</div>
    </div>
    <!-- nombre nombre-->
    <div class="table-mundial-group__div-table">
      <template v-if="data">
        <template v-for="(dataGroup, index) in data.data">
          <div
            class="table-mundial-group__div-table-row"
            :key="index"
            :class="teamselect == dataGroup.team_id ? 'color-green' : ''"
          >
            <div class="table-mundial-group__div-table-row__div-table-col position">
              {{ dataGroup.table_position }}.
            </div>
            <div class="table-mundial-group__div-table-row__div-table-col logo">
              <img
                :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + dataGroup.team_id + '.png'"
                width="22"
                :alt="dataGroup.team_name"
              />
            </div>
            <div
              class="table-mundial-group__div-table-row__div-table-col teamtable"
              @click="goToTeamProfile(dataGroup.team_id)"
            >
              {{ dataGroup.team_short_name }}
            </div>
            <div
              class="table-mundial-group__div-table-row__div-table-col jj"
              :class="{ 'clickable-value': !!dataGroup.games_played }"
              @click="setOpenMedia(dataGroup.team_id, 2, 3, 0, 0, 'Juegos jugados', false, dataGroup.games_played)"
            >
              {{ dataGroup.games_played }}
            </div>
            <div
              class="table-mundial-group__div-table-row__div-table-col jg"
              :class="{ 'clickable-value': !!dataGroup.games_won }"
              @click="setOpenMedia(dataGroup.team_id, 2, 3, 1, 0, 'Juegos ganados', false, dataGroup.games_won)"
            >
              {{ dataGroup.games_won }}
            </div>
            <div
              class="table-mundial-group__div-table-row__div-table-col je"
              :class="{ 'clickable-value': !!dataGroup.games_tied }"
              @click="setOpenMedia(dataGroup.team_id, 2, 3, 3, 0, 'Juegos empatados', false, dataGroup.games_tied)"
            >
              {{ dataGroup.games_tied }}
            </div>
            <div
              class="table-mundial-group__div-table-row__div-table-col jp"
              :class="{ 'clickable-value': !!dataGroup.games_lost }"
              @click="setOpenMedia(dataGroup.team_id, 2, 3, 2, 0, 'Juegos perdidos', false, dataGroup.games_lost)"
            >
              {{ dataGroup.games_lost }}
            </div>
            <div
              class="table-mundial-group__div-table-row__div-table-col gf movil-game-flag-g"
              :class="{ 'clickable-value': !!dataGroup.goals_scored }"
              @click="setOpenMedia(dataGroup.team_id, 1, 3, 0, 1000, 'Goles anotados', false, dataGroup.goals_scored)"
            >
              {{ dataGroup.goals_scored }}
            </div>
            <div
              class="table-mundial-group__div-table-row__div-table-col gc movil-game-flag-g"
              :class="{ 'clickable-value': !!dataGroup.goals_received }"
              @click="setOpenMedia(dataGroup.team_id, 3, 3, 0, 1001, 'Goles recibidos', true, dataGroup.goals_received)"
            >
              {{ dataGroup.goals_received }}
            </div>
            <div class="table-mundial-group__div-table-row__div-table-col dg movil-game-flag-g">
              {{ dataGroup.goals_difference }}
            </div>
            <div class="table-mundial-group__div-table-row__div-table-col pts">{{ dataGroup.points }}</div>
            <div class="table-mundial-group__div-table-row__div-table-col lastgames">
              <template v-if="dataGroup.last_five_games">
                <template v-for="(game, index) in dataGroup.last_five_games">
                  <div
                    :key="index"
                    class="table-mundial-group__div-table-row__div-table-col__game red"
                    :class="[
                      game,
                      dataGroup.last_five_games.length == 5
                        ? 'movil-game-flag-' + index
                        : dataGroup.last_five_games.length > 3
                        ? 'movil-game-flag-' + index + 1
                        : '',
                    ]"
                  >
                    {{ game }}
                  </div>
                </template>
              </template>
              <template v-else>-</template>
            </div>
            <div class="table-mundial-group__div-table-row__div-table-col prox">
              <template v-if="dataGroup.next_rival_logo != '-'">
                <img
                  :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + dataGroup.next_rival + '.png'"
                  width="22"
                  :alt="dataGroup.next_rival_name"
                />
              </template>
              <template v-else><span>-</span></template>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <template v-for="indexPlace in 4">
          <div :key="indexPlace" class="placeholder-item"></div>
        </template>
      </template>
    </div>
    <!-- nombre nombre-->
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'TableMundialGroup',
  components: {},
  props: {
    header: { type: Boolean, default: true },
    teamselect: { type: Number, default: 0 },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
    };
  },
  computed: {
    ...mapState('loginGeneral', ['tournamentsForMediaPlayer']),
    ...mapGetters('loginGeneral', ['getSeasonSelected']),
  },
  watch: {},
  methods: {
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    goToTeamProfile(team) {
      this.$router.push(`/teamsAnalysis/${team}`);
    },
    setOpenMedia(
      team,
      mainSectionType,
      playListType,
      matchResult,
      category,
      title = '',
      isRivalSubject = false,
      value,
    ) {
      if (!value) {
        return;
      }
      const allResults = [1, 2, 3];
      const categoryF =
        category != 0
          ? category == 1000
            ? [12, 55, '35_r', '54_r']
            : category == 1001
            ? ['57_r', '326_r', '56_r', '60_r', '59_r', '55_r', 35, 54]
            : category
          : [];
      let jsonConfig = {
        seasonId: this.getSeasonSelected,
        tournaments: this.tournamentsForMediaPlayer,
        mainSectionType: 1,
        playListType: playListType,
        categoryIds: categoryF,
        gameIds: null,
        playerIds: [],
        teamId: team,
        matchResult: !matchResult ? allResults : [matchResult],
        isRivalSubject,
        playData: {},
        advancedFilter: {
          playListTitle: title,
        },
      };
      if (category !== 0) {
        jsonConfig.advancedFilter.mainCategoryId = category;
      }
      this.setModalInitialState(jsonConfig);
      this.setIsModalOpen(true);
    },
  },
  async created() {},
  mounted() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.color-green {
  background: #deefae !important;
}
.placeholder-item:nth-of-type(odd) {
  background-color: #f5f5f5;
  box-shadow: 0 1px 2px 0 rgba(33, 33, 33, 0.05);
}
.placeholder-item {
  height: 32px;
  position: relative;
  overflow: hidden;
}
.placeholder-item:nth-of-type(odd)::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(to right, transparent 0%, #e8e8e8 50%, transparent 100%);
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.table-mundial-group {
  width: 100%;
  height: auto;
  &__grouptitle {
    width: 100%;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    font-family: 'Avenir-Bold';
    letter-spacing: -0.25px;
    text-align: left;
    color: #132839;
    padding-left: 10px;
  }
  &__head {
    display: table;
    height: 20px;
    width: 100%;
    border-radius: 4px;
    border-radius: 4px;
    overflow: hidden;
    @media screen and (max-width: 450px) {
      border-radius: 0px;
      border-radius: 0px;
    }

    &__div-table-col-head {
      float: left;
      display: table-column;
      width: 10%;
      height: 20px;
      line-height: 20px;
      background: #f2f4f9;
      font-size: 10px;

      text-align: center;
      font-family: 'Avenir-Demi';
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.22px;
      color: #132839;
      @media screen and (max-width: 430px) {
        font-size: 9.7px;
      }
    }

    &__div-table-col-head.position {
      width: 8% !important;

      @media screen and (max-width: 480px) {
        width: 10.2% !important;
      }
      @media screen and (max-width: 380px) {
        width: 11.2% !important;
      }
    }
    &__div-table-col-head.teamtable {
      width: 16.5% !important;
      text-align: center !important;
      @media screen and (max-width: 480px) {
        width: 18.8% !important;
      }
      @media screen and (max-width: 380px) {
        width: 22.3% !important;
      }
    }
    &__div-table-col-head.jj {
      width: 4.8% !important;
      @media screen and (max-width: 480px) {
        width: 4.7% !important;
      }
      @media screen and (max-width: 380px) {
        width: 6.92% !important;
      }
    }
    &__div-table-col-head.jg {
      width: 5% !important;
      @media screen and (max-width: 480px) {
        width: 4.7% !important;
      }
      @media screen and (max-width: 380px) {
        width: 6.92% !important;
      }
    }
    &__div-table-col-head.je {
      width: 4.9% !important;
      @media screen and (max-width: 480px) {
        width: 4.92% !important;
      }
      @media screen and (max-width: 380px) {
        width: 6.92% !important;
      }
    }
    &__div-table-col-head.jp {
      width: 5% !important;
      @media screen and (max-width: 480px) {
        width: 4.92% !important;
      }
      @media screen and (max-width: 380px) {
        width: 6.92% !important;
      }
    }
    &__div-table-col-head.gf {
      width: 4.9% !important;
      @media screen and (max-width: 480px) {
        width: 4.92% !important;
      }
      @media screen and (max-width: 380px) {
        width: 6.92% !important;
      }
    }
    &__div-table-col-head.gc {
      width: 4.8% !important;
      @media screen and (max-width: 480px) {
        width: 4.92% !important;
      }
      @media screen and (max-width: 380px) {
        width: 6.92% !important;
      }
    }
    &__div-table-col-head.dg {
      width: 4.9% !important;
      @media screen and (max-width: 480px) {
        width: 4.92% !important;
      }
      @media screen and (max-width: 380px) {
        width: 6.92% !important;
      }
    }
    &__div-table-col-head.pts {
      width: 7% !important;
    }
    &__div-table-col-head.lastgames {
      width: 23.4% !important;
      @media screen and (max-width: 480px) {
        width: 22% !important;
      }
      @media screen and (max-width: 380px) {
        width: 21.2% !important;
      }
    }
    &__div-table-col-head.prox {
      width: 10.8% !important;
      @media screen and (max-width: 480px) {
        width: 8% !important;
      }
      @media screen and (max-width: 380px) {
        width: 10.5% !important;
      }
    }
  }
  &__div-table {
    display: table;
    width: 100%;
  }
  &__div-table-row:nth-of-type(even) {
    background-color: #f7faf9;
  }
  &__div-table-row {
    display: table-row;
    width: auto;
    clear: both;
    height: 32px;

    &__div-table-col {
      float: left;
      display: table-column;
      width: 10%;
      height: 32px;
      line-height: 34px;

      &__game {
        width: 20px;
        height: 20px;
        margin-top: 6px;
        border-radius: 32px;
        margin-left: 2px;
        margin-right: 2px;
        font-family: 'Avenir-Demi';
        font-size: 12px;
        line-height: 22px;
        color: #ffffff;
        @media screen and (max-width: 506px) {
          margin-left: 2px;
          margin-right: 0px;
        }
        @media screen and (max-width: 480px) {
          width: 16px !important;
          height: 16px !important;
          font-size: 10px !important;
          margin-top: 9px;
          margin-left: 2px;
          margin-right: 2px;
          line-height: 16px;
          padding-right: 0px;
        }
      }
      &__game.P {
        background-color: #eb2424;
        padding-left: 1px;
        @media screen and (max-width: 480px) {
          padding-left: 0px;
        }
      }
      &__game.G {
        background-color: #73d44e;
        @media screen and (max-width: 480px) {
          padding-right: 1px;
        }
      }
      &__game.E {
        background-color: #ababab;
      }
    }

    &__div-table-col.position {
      width: 7% !important;
      font-family: 'Avenir-Medium';
      font-size: 13.2px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      padding-left: 7px;
      letter-spacing: -0.49px;
      color: #132839;
      @media screen and (max-width: 550px) {
        padding-left: 5px;
      }
      @media screen and (max-width: 480px) {
        width: 9% !important;
      }
      @media screen and (max-width: 380px) {
        width: 10% !important;
      }
    }
    &__div-table-col.logo {
      width: 7% !important;
      padding-top: 5px;
      @media screen and (max-width: 480px) {
        padding-right: 3px;
        width: 7.5% !important;
      }
      @media screen and (max-width: 380px) {
        width: 10% !important;
      }
    }
    &__div-table-col.teamtable {
      width: 10% !important;
      text-align: left;
      text-decoration: underline;
      font-family: 'Avenir-Demi';
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #132839;
      cursor: pointer;
      @media screen and (max-width: 480px) {
        width: 11.5% !important;
      }
      @media screen and (max-width: 380px) {
        width: 12.8% !important;
      }
    }
    &__div-table-col.jj {
      width: 5% !important;
      font-family: 'Avenir-Medium';
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      text-align: center;
      letter-spacing: -0.45px;
      color: #132839;
      @media screen and (max-width: 480px) {
        width: 4.92% !important;
      }
      @media screen and (max-width: 380px) {
        width: 7.2% !important;
      }
    }
    &__div-table-col.jg {
      width: 5% !important;
      font-family: 'Avenir-Medium';
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      text-align: center;
      letter-spacing: -0.45px;
      color: #132839;
      @media screen and (max-width: 480px) {
        width: 4.92% !important;
      }
      @media screen and (max-width: 380px) {
        width: 7.2% !important;
      }
    }
    &__div-table-col.je {
      width: 5% !important;
      font-family: 'Avenir-Medium';
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      text-align: center;
      letter-spacing: -0.45px;
      color: #132839;
      @media screen and (max-width: 480px) {
        width: 5.4% !important;
      }
      @media screen and (max-width: 380px) {
        width: 7% !important;
      }
    }
    &__div-table-col.jp {
      width: 5% !important;
      font-family: 'Avenir-Medium';
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      text-align: center;
      letter-spacing: -0.45px;
      color: #132839;
      @media screen and (max-width: 480px) {
        width: 4.92% !important;
      }
      @media screen and (max-width: 380px) {
        width: 7.2% !important;
      }
    }
    &__div-table-col.gf {
      width: 5% !important;
      font-family: 'Avenir-Medium';
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      text-align: center;
      letter-spacing: -0.45px;
      color: #132839;
      @media screen and (max-width: 480px) {
        width: 4.92% !important;
      }
      @media screen and (max-width: 380px) {
        width: 7.2% !important;
      }
    }
    &__div-table-col.gc {
      width: 5% !important;
      font-family: 'Avenir-Medium';
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      text-align: center;
      letter-spacing: -0.45px;
      color: #132839;
      @media screen and (max-width: 480px) {
        width: 5.3% !important;
      }
      @media screen and (max-width: 380px) {
        width: 6.92% !important;
      }
    }
    &__div-table-col.dg {
      width: 5% !important;
      font-family: 'Avenir-Medium';
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      text-align: center;
      letter-spacing: -0.45px;
      color: #132839;
      @media screen and (max-width: 480px) {
        width: 5.3% !important;
      }
      @media screen and (max-width: 380px) {
        width: 7.2% !important;
      }
    }
    &__div-table-col.pts {
      width: 7% !important;
      font-family: 'Avenir-Bold';
      font-size: 13.2px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.49px;
      color: #132839;
      @media screen and (max-width: 480px) {
        width: 7.2% !important;
      }
    }
    &__div-table-col.lastgames {
      width: 24% !important;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 480px) {
        width: 22.7% !important;
      }
      @media screen and (max-width: 380px) {
        width: 22% !important;
      }
    }
    &__div-table-col.prox {
      width: 10% !important;
      padding-top: 5px;
      padding-left: 6px;
      @media screen and (max-width: 480px) {
        width: 6.4% !important;
        padding-left: 1px;
      }
      @media screen and (max-width: 380px) {
        width: 9.3% !important;
      }
    }
  }
  .movil-game-flag-lastgame-movil {
    display: none;
  }
  @media screen and (max-width: 880px) {
    .movil-game-flag-0,
    .movil-game-flag-1 {
      display: none;
    }
    .movil-game-flag-lastgame-movil {
      display: inline-block;
    }
    .movil-game-flag-lastgame {
      display: none;
    }
  }
  @media screen and (max-width: 380px) {
    .movil-game-flag-g {
      display: none;
    }
  }
}
.clickable-value {
  text-decoration: underline;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
    color: #00a5ff;
  }
}
</style>
